module.exports = new __parcel__URL__("webcam.15d4ed6b.svg").toString();